<template>
    <div :id="'regional_good--' + item.id"
         class="item pb-3 mb-5 border-bottom">

        <transition mode="out-in" name="slide">
            <div v-if="!isEdit" class="row">

                <div class="col-5 mb-3">
                    <img :src="imagePath" alt="" class="image mw-100">
                </div>

                <div class="col-7">
                    <!--            Name -->
                    <h2 v-if="element.name">{{ !online ? 'Offline - ' : '' }}{{ element.name }}</h2>
                    <!--            Price -->
                    <h2 v-if="element.price && element.price > 0" class="font-weight-bold">€ {{ element.price }}</h2>
                    <!--            Link -->
                    <a v-if="element.url" :href="element.url" class="btn btn-sm btn-secondary mt-3" target="_blank">zum Hersteller<i class="fas fa-external-link-square ml-2"></i></a>
                </div>

                <!--            State -->
                <p v-if="element.state.name" class="col-12 mt-2"><i class="fad fa-map-pin mr-2"></i> {{ element.state.name }}</p>

                <p v-if="element.category.name" class="col-12"><i class="fad fa-folders mr-2"></i>{{ element.category.name }}</p>
                <!--            Date -->
                <p class="col-12"><i class="fad fa-calendar-week mr-2"></i> Angebot gültig: {{ validity }}</p>



                <!--            Description -->
                <div v-if="element.description" class="col-12" v-html="element.description"></div>

                <!--            Buttons -->
                <buttons :isLoading="isLoading" @delete="deleteItem(item.id)" @edit="isEdit = true"></buttons>
            </div>

            <buero-form
                v-if="isEdit"
                :elementValues="this.element"
                :schema="schema"
                method="patch"
                url="/api/merchant/regional-goods"
                @cancel="cancelEdit"
                @updateItem="updateItem"></buero-form>
        </transition>
    </div>
</template>

<script>
import {Form} from './Form';

export default {
    name: 'RegionalGood',
    props: {
        item: Object,
        categoryOptions: Array,
        locationOptions: Array,
    },
    data() {
        return {
            isEdit: false,
            element: this.item,
            errors: {},
            isLoading: false,
            schema: [],
        };
    },

    mounted() {
        this.schema = (new Form(this.categoryOptions, this.locationOptions)).schema();
    },

    methods: {
        cancelEdit() {
            this.isEdit = false;
        },

        updateItem(payload) {
            this.element = payload;
            this.isEdit = false;
        },

        deleteItem(payload) {
            this.$swal({
                title: 'Sind Sie sicher?',
                text: 'Sie können dies nicht rückgängig machen!',
                showDenyButton: true,
                confirmButtonText: `Löschen`,
                denyButtonText: `Nicht löschen`,
            }).then((result) => {
                if (result.isConfirmed) {
                    this.isLoading = true;
                    axios.delete('/api/merchant/regional-goods/' + payload).then((response) => {
                        this.$swal({
                            title: response.data.message,
                        });
                        this.isLoading = false;
                        this.$emit('deleteItem', payload);
                    }).catch((error) => {
                        this.$swal({
                            icon: 'error',
                            title: 'Es ist ein Fehler aufgetreten',
                        });
                        this.isLoading = false;
                    });
                }
            });
        },
    },

    computed: {
        imagePath() {
            if (this.element.media.length > 0) {
                return this.element.media[0].url;
            }
            return '/images/placeholder.png';
        },

        validity() {
            if (this.element.visible_from && this.element.visible_to) {
                return 'von ' + moment(this.element.visible_from).format('LL') + ' bis ' + moment(this.element.visible_to).format('LL');
            } else if (this.element.visible_from && this.element.visible_to === null) {
                return 'ab ' + moment(this.element.visible_from).format('LL');
            } else if (this.element.visible_to && this.element.visible_from === null) {
                return 'bis ' + moment(this.element.visible_to).format('LL');
            }

            return 'dauerhaft';
        },

        online() {
            let tmpDate = moment().format('YYYY-MM-DD');

            if (this.element.visible_from && this.element.visible_to) {
                return moment(tmpDate).isBetween(this.element.visible_from, this.element.visible_to, null, '[]');
            } else if (this.element.visible_from && this.element.visible_to === null) {
                return moment(tmpDate).isAfter(this.element.visible_from);
            } else if (this.element.visible_to && this.element.visible_from === null) {
                return moment(tmpDate).isBefore(this.element.visible_to);
            }

            return true;
        },
    },
};
</script>
